module.exports = __webpack_public_path__ + "media/gem-found-pink.bcd79ff4.mp4";